var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _rect, _path26, _path27, _rect2, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _ellipse8, _ellipse9, _ellipse10, _ellipse11, _ellipse12, _ellipse13, _ellipse14, _ellipse15, _ellipse16, _path28, _path29, _path30, _path31, _path32, _path33, _path34;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIllustration(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 157,
    height: 122,
    viewBox: "0 0 157 122",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M148.548 47.0314C145.657 36.3919 135.52 29.1782 125.971 22.2721C117.06 15.8262 107.429 9.68338 95.6323 8.75822C83.9994 7.84588 73.6949 14.6295 62.2005 17.2707C45.2139 21.1738 23.873 16.162 12.3013 27.9056C0.885713 39.4908 5.05936 57.0956 8.87535 71.3878C12.4748 84.8691 19.7431 98.1368 33.0213 105.509C45.3154 112.335 61.4492 110.454 76.3747 108.866C88.3179 107.594 98.5373 102.112 109.463 97.3737C120.97 92.3838 134.585 89.7833 141.796 80.4954C149.392 70.7119 151.557 58.0996 148.548 47.0314Z",
    fill: "#EFF0F9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M142.201 15.014C140.926 14.7832 139.693 15.3741 138.52 15.9255C137.425 16.4402 136.331 17.0347 135.7 18.07C135.077 19.0909 135.343 20.3485 135.109 21.5222C134.764 23.2565 133.263 24.9741 134.005 26.5784C134.737 28.161 136.819 28.5988 138.528 28.9151C140.14 29.2134 141.895 29.1664 143.286 28.2957C144.574 27.4896 145.099 25.9272 145.6 24.4889C146.002 23.338 145.873 22.1487 145.855 20.9295C145.837 19.6454 146.171 18.2798 145.496 17.1884C144.786 16.0388 143.527 15.254 142.201 15.014Z",
    fill: "#EFF0F9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.9061 94.6001C90.7007 89.5597 93.459 110.597 104.594 98.8859C110.814 92.345 85.8075 93.7629 95.2349 90.1399C106.796 85.6993 123.413 88.9822 131.931 98.4673C136.144 103.156 142.619 107.987 136.505 114.75C127.482 124.731 103.626 119.623 93.7028 112.646C87.8762 108.549 80.9673 99.7912 85.9061 94.6001Z",
    fill: "#A1A4D6",
    stroke: "#A1A4D6",
    strokeWidth: 1.58039,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.322 111.735C102.91 112.131 95.4054 112.807 95.4854 109.329C95.5158 107.955 99.2375 108.879 100.417 109.184C101.17 109.38 104.27 110.822 103.322 111.735Z",
    fill: "#4CB963",
    stroke: "#4CB963",
    strokeWidth: 1.58039,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M115.181 116.679C115.93 117.203 106.013 118.342 106.363 114.998C106.694 111.821 121.837 115.736 113.62 117.163",
    fill: "#B68CB8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M115.181 116.679C115.93 117.203 106.013 118.342 106.363 114.998C106.694 111.821 121.837 115.736 113.62 117.163",
    stroke: "#B68CB8",
    strokeWidth: 1.58039,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M126.577 117.982C125.411 118.842 118.828 118.372 120.978 115.884C124.558 111.747 132.057 117.031 126.577 117.982Z",
    fill: "#FFC107",
    stroke: "#FFC107",
    strokeWidth: 1.58039,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M129.374 101.517C129.958 103.816 118.611 100.513 120.763 97.6432C124.19 93.0732 129.374 101.517 129.374 101.517Z",
    fill: "#F57C00",
    stroke: "#F57C00",
    strokeWidth: 1.58039,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M87.1987 97.8769C86.8471 97.8843 88.6329 97.2379 89.2154 97.8964",
    stroke: "black",
    strokeWidth: 1.58039,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M99.3355 103.883C100.784 105.33 95.4579 103.992 94.3299 101.736",
    stroke: "black",
    strokeWidth: 1.58039,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M104.875 89.1517C109.012 89.1633 112.728 88.8087 116.583 90.5881",
    stroke: "black",
    strokeWidth: 1.58039,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.1834 97.856C32.3372 97.6455 21.3085 105.101 17.1765 107.919C14.3996 110.014 11.7702 112.657 12.1078 113.028C12.1078 113.028 14.6109 113.611 18.9634 112.799C25.5594 111.118 28.7592 108.79 34.1537 106.26C34.7697 105.971 39.868 102.745 39.8906 102.771",
    fill: "#4CB963"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1834 97.856C32.3372 97.6455 21.3085 105.101 17.1765 107.919C14.3996 110.014 11.7702 112.657 12.1078 113.028C12.1078 113.028 14.6109 113.611 18.9634 112.799C25.5594 111.118 28.7592 108.79 34.1537 106.26C34.7697 105.971 39.868 102.745 39.8906 102.771",
    stroke: "#4CB963",
    strokeWidth: 1.70393,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.9358 96.157C45.3028 96.1178 44.4449 96.0494 40.1989 96.5473C40.1135 96.5639 36.7802 97.1057 36.8501 97.3573C37.2066 98.6408 36.7896 97.3842 38.5067 101.348C39.3011 103.18 39.0977 103.316 39.3011 103.18C40.5318 102.35 46.5715 98.3151 47.343 97.1586C48.6039 95.2669 44.8296 96.1687 44.9358 96.157Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 1.70393,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9737 97.3L40.943 100.753L38.9726 98.12L42.8017 96.0549L44.714 95.848L44.9737 97.3Z",
    fill: "black"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M35.208 100.063C31.0984 100.565 19.4845 106.567 17.2188 110.014",
    stroke: "black",
    strokeWidth: 1.70393,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.7536 99.638C46.2963 100.418 48.5294 100.211 49.3284 100.237C53.7335 100.388 55.8036 96.3126 58.0808 93.3888C58.4581 92.9026 60.5389 91.677 60.5818 91.4296C60.6669 90.963 57.5532 91.6197 57.4904 90.8979C57.3795 89.6496 61.1782 88.0624 60.9791 87.3875C60.829 86.88 56.5833 86.9531 56.0448 86.9326C50.0667 86.7289 45.7219 89.382 42.937 94.5133",
    fill: "#936742"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0688 97.3034C49.3476 96.9268 51.2378 95.848 52.8849 94.2886",
    stroke: "#000808",
    strokeWidth: 1.70393,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.0423 100.454C43.7942 100.428 47.0312 101.288 46.9507 99.4031C46.8845 97.8199 44.5712 94.0353 42.6594 94.3165C40.0035 94.7082 42.1351 97.9006 42.5821 98.9691C42.8514 99.6107 44.0423 100.454 44.0423 100.454Z",
    fill: "#D26556",
    stroke: "#D26556",
    strokeWidth: 1.70393,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.3432 114.276C57.8665 113.637 38.9633 110.921 39.1206 115.59C39.2695 120.025 69.0043 116.345 53.4149 113.426",
    fill: "#F2C94C"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M56.3432 114.276C57.8665 113.637 38.9633 110.921 39.1206 115.59C39.2695 120.025 69.0043 116.345 53.4149 113.426",
    stroke: "#F2C94C",
    strokeWidth: 1.39032,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.8875 112.288C62.1613 112.173 58.7639 111.685 58.7922 112.524C58.8189 113.321 64.163 112.66 61.3612 112.135",
    fill: "#F2C94C"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8875 112.288C62.1613 112.173 58.7639 111.685 58.7922 112.524C58.8189 113.321 64.163 112.66 61.3612 112.135",
    stroke: "#F2C94C",
    strokeWidth: 1.39032,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.1495 111.343C56.2185 111.373 55.36 111.493 55.368 111.28C55.3756 111.078 56.7245 111.251 56.0164 111.382",
    fill: "#F2C94C"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1495 111.343C56.2185 111.373 55.36 111.493 55.368 111.28C55.3756 111.078 56.7245 111.251 56.0164 111.382",
    stroke: "#F2C94C",
    strokeWidth: 1.39032,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 48.9163,
    y: 14.6875,
    width: 56.9758,
    height: 57.2466,
    stroke: "#FFC107",
    strokeWidth: 12.815
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M82.8842 10.302C83.5579 7.93643 78.6864 9.82225 79.7512 11.2483C79.7499 12.431 85.1185 12.0641 86.6844 12.0641C87.1418 12.1498 105.112 11.8338 105.225 12.0641C105.285 12.1867 105.825 13.7116 105.755 13.8293C106.516 13.3458 108.621 12.3252 109.149 13.5269L109.131 30.4185C109.127 33.9671 109.32 61.4079 109.316 64.7197C109.27 65.0765 109.53 70.4478 109.312 70.6334C109.109 70.8068 108.421 70.3435 107.969 70.6334C106.63 71.4935 107.843 73.5349 107.293 74.8914C107.131 75.2926 84.7073 74.9104 84.3386 74.7487C83.9548 75.0295 83.6997 76.319 81.878 76.0961",
    stroke: "black",
    strokeOpacity: 0.85,
    strokeWidth: 1.29921,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M72.5396 10.302C71.866 7.93643 76.7375 9.82225 75.6726 11.2483C75.6739 12.431 70.3053 12.0641 68.7395 12.0641C68.2821 12.1498 50.312 11.8338 50.199 12.0641C50.1389 12.1867 49.5992 13.7116 49.6691 13.8293C48.9076 13.3458 46.8032 12.3252 46.2749 13.5269L46.293 30.4185C46.2968 33.9671 46.1039 61.4079 46.1074 64.7197C46.154 65.0765 45.8942 70.4478 46.112 70.6334C46.3153 70.8068 47.0033 70.3435 47.4546 70.6334C48.7937 71.4935 47.581 73.5349 48.1307 74.8914C48.293 75.2926 70.7166 74.9104 71.0853 74.7487C71.469 75.0295 71.7241 76.319 73.5458 76.0961",
    stroke: "black",
    strokeOpacity: 0.85,
    strokeWidth: 1.29921,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 48.772,
    y: 14.5674,
    width: 56.8168,
    height: 57.0372,
    fill: "#1F224A"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 62.0853,
    cy: 30.1576,
    rx: 0.417784,
    ry: 0.420344,
    fill: "#FFC107"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 66.0794,
    cy: 19.4681,
    rx: 0.417783,
    ry: 0.420344,
    fill: "#FFC107"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 72.7366,
    cy: 60.4463,
    rx: 0.417784,
    ry: 0.420343,
    fill: "#FFC107"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 57.2029,
    cy: 64.4551,
    rx: 0.417784,
    ry: 0.420341,
    fill: "#FFC107"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 83.3885,
    cy: 64.9005,
    rx: 0.417782,
    ry: 0.420343,
    fill: "#FFC107"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 98.0345,
    cy: 54.655,
    rx: 0.417782,
    ry: 0.42034,
    fill: "#FFC107"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 81.1693,
    cy: 18.1313,
    rx: 0.417784,
    ry: 0.420344,
    fill: "#FFC107"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 53.6526,
    cy: 48.8654,
    rx: 0.417783,
    ry: 0.420343,
    fill: "#FFC107"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 54.5403,
    cy: 22.1401,
    rx: 0.417783,
    ry: 0.420344,
    fill: "#FFC107"
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 52.3211,
    cy: 34.6119,
    rx: 0.417783,
    ry: 0.420344,
    fill: "#FFC107"
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 94.4837,
    cy: 29.7117,
    rx: 0.417786,
    ry: 0.420344,
    fill: "#FFC107"
  })), _ellipse12 || (_ellipse12 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 98.0345,
    cy: 39.5115,
    rx: 0.417782,
    ry: 0.420344,
    fill: "#FFC107"
  })), _ellipse13 || (_ellipse13 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 92.7083,
    cy: 51.0919,
    rx: 0.417788,
    ry: 0.420345,
    fill: "#FFC107"
  })), _ellipse14 || (_ellipse14 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 98.9217,
    cy: 65.3459,
    rx: 0.41778,
    ry: 0.420343,
    fill: "#FFC107"
  })), _ellipse15 || (_ellipse15 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 89.158,
    cy: 21.6947,
    rx: 0.417782,
    ry: 0.420344,
    fill: "#FFC107"
  })), _ellipse16 || (_ellipse16 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 100.697,
    cy: 23.4763,
    rx: 0.417786,
    ry: 0.420344,
    fill: "#FFC107"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M75.2588 25.9734C75.6182 23.9486 78.2761 23.4127 79.3582 25.1468L83.7584 32.1987C84.1861 32.8841 84.9524 33.2808 85.7615 33.2357L92.5253 32.8578C94.3987 32.7532 95.5411 34.8666 94.438 36.3964L89.9017 42.6874C89.3746 43.4183 89.3312 44.3901 89.7914 45.1566L93.2335 50.8893C94.2631 52.6041 92.6824 54.724 90.744 54.2279L82.1828 52.0368C81.5198 51.8671 80.813 52.0125 80.2655 52.4312L73.614 57.5177C71.9964 58.7546 69.7202 57.3834 70.0648 55.3796L71.414 47.5334C71.5682 46.6368 71.1676 45.7404 70.3998 45.2641L63.6444 41.0735C61.9678 40.0334 62.386 37.4725 64.311 36.9919L72.2976 34.998C73.1615 34.7824 73.8205 34.0756 73.9763 33.1977L75.2588 25.9734Z",
    fill: "#FFC107"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.9968 59.9375C51.9286 58.0662 53.2456 57.5438 56.8246 54.7627C61.2983 51.8434 62.831 49.5028 65.1557 46.255C66.8962 43.8229 68.4316 40.4007 70.8155 38.833C70.9481 38.7462 72.9529 37.1799 72.9712 37.6838C73.0026 38.5712 69.3411 42.965 69.4886 43.6917C69.5072 43.785 71.0021 42.1254 71.1495 41.974C72.3897 40.7012 73.7181 39.1621 75.1418 38.2942C75.2588 38.2227 76.6866 37.0917 76.7638 37.6923C76.8378 38.2683 73.115 43.0992 72.5611 43.8876C72.4588 44.0341 71.4504 45.5124 71.5485 45.6262C71.6054 45.6909 72.8219 44.2593 72.918 44.1537C73.4214 43.6029 73.9245 43.0997 74.4583 42.5869C74.8446 42.2155 77.8004 39.4044 77.994 39.833C78.0773 40.0164 77.7589 40.4502 77.6586 40.6076C76.4749 42.4602 74.8787 44.315 73.5219 46.0088C73.4104 46.148 72.2616 47.6064 72.4493 47.8226C72.4997 47.8804 73.5681 46.6373 73.6978 46.5008C74.9177 45.2214 76.1253 43.7074 77.5309 42.7828C77.6649 42.6948 77.8438 42.4167 77.9325 42.5189C77.9798 42.5741 77.8806 42.917 77.8387 42.992C77.0951 44.3156 75.0753 46.23 74.9449 47.7905C74.93 47.9667 74.996 48.0422 75.1428 48.0177C75.7328 47.9176 77.0752 48.1477 77.1102 49.1194C77.141 49.9808 75.5796 50.6046 75.1192 50.8932C72.9996 52.2204 70.7226 52.7434 68.5651 54.0944C66.6799 55.2753 64.6874 56.1097 62.8577 57.5438C59.8646 59.8889 51.8921 66.8584 48.9973 69.2942",
    fill: "#AE7544"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9968 59.9375C51.9286 58.0662 53.2456 57.5438 56.8246 54.7627C61.2983 51.8434 62.831 49.5028 65.1557 46.255C66.8962 43.8229 68.4316 40.4007 70.8155 38.833C70.9481 38.7462 72.9529 37.1799 72.9712 37.6838C73.0026 38.5712 69.3411 42.965 69.4886 43.6917C69.5072 43.785 71.0021 42.1254 71.1495 41.974C72.3897 40.7012 73.7181 39.1621 75.1418 38.2942C75.2588 38.2227 76.6866 37.0917 76.7638 37.6923C76.8378 38.2683 73.115 43.0992 72.5611 43.8876C72.4588 44.0341 71.4504 45.5124 71.5485 45.6262C71.6054 45.6909 72.8219 44.2593 72.918 44.1537C73.4214 43.6029 73.9245 43.0997 74.4583 42.5869C74.8446 42.2155 77.8004 39.4044 77.994 39.833C78.0773 40.0164 77.7589 40.4502 77.6586 40.6076C76.4749 42.4602 74.8787 44.315 73.5219 46.0089C73.4104 46.148 72.2616 47.6064 72.4493 47.8226C72.4997 47.8804 73.5681 46.6373 73.6978 46.5008C74.9177 45.2214 76.1253 43.7074 77.5309 42.7828C77.6649 42.6948 77.8438 42.4167 77.9325 42.5189C77.9798 42.5741 77.8806 42.917 77.8387 42.992C77.0951 44.3156 75.0753 46.23 74.9449 47.7905C74.93 47.9667 74.996 48.0422 75.1428 48.0177C75.7328 47.9176 77.0752 48.1477 77.1102 49.1194C77.141 49.9808 75.5796 50.6046 75.1192 50.8932C72.9996 52.2204 70.7226 52.7434 68.5651 54.0944C66.6799 55.2753 64.6874 56.1097 62.8577 57.5438C59.8646 59.8889 51.8921 66.8584 48.9973 69.2942L48.9968 59.9375Z",
    stroke: "#AE7544",
    strokeWidth: 0.859375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M69.6348 43.3454C70.1971 42.2754 73.6063 38.6377 74.6569 38.2962",
    stroke: "black",
    strokeWidth: 0.859375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M71.5938 45.7032C72.287 43.9645 75.7349 40.9241 77.1229 40.022",
    stroke: "black",
    strokeWidth: 0.859375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M77.473 42.4551C75.7755 43.8577 74.1424 45.7972 72.917 47.8032",
    stroke: "black",
    strokeWidth: 0.859375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M65.9214 44.3927C67.5268 42.1194 68.8601 39.9339 71.1448 38.7821",
    stroke: "black",
    strokeWidth: 0.859375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustration);
export default __webpack_public_path__ + "static/media/illustration.84bdd9f82c789219e2b4075a1b97d7e1.svg";
export { ForwardRef as ReactComponent };